import React, { useCallback } from 'react'
import EditWorkflowModal from '../../Designer/EditWorkflowModal.jsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getCurrentScreenType } from 'Helper/screenTypeHelpers'
import { openModal, closeModal } from 'actions/modalActions'
import { useSelector, useDispatch } from 'react-redux'
import { getContextName } from 'Helper/routeHelpers'
import { useLocation } from 'react-router-dom'
import LinkItem from './LinkItem.jsx'
import PropTypes from 'prop-types'
import _ from 'lodash'

const WorkflowSubmenu = ({ workflows, disabled, prefix }) => {

  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const screenType = _.capitalize(getCurrentScreenType())
  const isDesignMode = useSelector(state => state.interactableState.uiDesignMode)
  const currentContext = getContextName(pathname)
  const showConfigure = isDesignMode && (currentContext === 'adminDisplay' || currentContext === 'patientDisplay')
  const currentWorkflowPath = useSelector(state => state.router?.match?.params?.workflow)
  const isEdit = showConfigure && currentWorkflowPath && currentWorkflowPath !== ''

  const addWorkflowModal = useCallback((isEdit) => {
    dispatch(openModal(
      'edit_workflow_modal',
      {
        title: 'Configure ' + screenType + ' Workflow',
        content: (
          <EditWorkflowModal
            isEdit={isEdit}
            closeSelf={() => { dispatch(closeModal('edit_workflow_modal')) }}
          />
        ),
        closeable: true
      })
    )
  }, [isDesignMode, screenType, openModal, closeModal])

  if ((workflows == null || workflows.length === 0) && !showConfigure) {
    return null
  } else {
    const workflowList = workflows.sort((a, b) => {
      const textA = a.name ? a.name.toUpperCase() : ''
      const textB = b.name ? b.name.toUpperCase() : ''
      return textA < textB ? -1 : textA > textB ? 1 : 0
    })
    const disabledClass = disabled ? ' disabled' : ''

    return (
      <li className={'dropdown-submenu' + disabledClass}>
        <a
          className="dropdown-toggle"
          id="workflowsDropDown"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
          aria-label="workflows menu"
        >
          <FontAwesomeIcon icon={['fas', 'step-forward']} /> Workflows
        </a>
        {disabled
          ? null
          : (
            <ul
              className="dropdown-menu dropdown-menu-right"
              aria-labelledby="workflowsDropDown"
            >
              {
                workflowList.map((workflow, idx) => {
                  return (
                    <LinkItem
                      key={idx}
                      type="workflow"
                      item={workflow}
                      prefix={prefix}
                    />
                  )
                })
              }
              {
                showConfigure && isEdit
                  ? <li key={'add workflow'}>
                    <a
                      role="button"
                      aria-label={`add workflow link`}
                      onClick={() => {
                        addWorkflowModal(true)
                      }}
                    >
                      &lt;Edit Current Workflow&gt;
                    </a>
                  </li>
                  : null
              }
              {
                showConfigure
                  ? <li key={'add workflow'}>
                    <a
                      role="button"
                      aria-label={`add workflow link`}
                      onClick={() => {
                        addWorkflowModal(false)
                      }}
                    >
                      &lt;Add Workflow&gt;
                    </a>
                  </li>
                  : null
              }
            </ul>
          )}
      </li>
    )
  }
}

WorkflowSubmenu.propTypes = {
  // A route that may need to be prefixed to the paths in the workflow menu for example,
  // from the patient menu, workflows will need to be prefixed by /dashboard/patient/:patientId
  prefix: PropTypes.string,
  // An array of workflow objects
  workflows: PropTypes.arrayOf(
    PropTypes.shape({
      // User visible workflow name
      name: PropTypes.string.isRequired,
      // Workflow name used in the url
      path: PropTypes.string.isRequired,
      // Should the workflow be listed in the workflow menu
      selectable: PropTypes.bool.isRequired,
      // Array of screens in the workflow
      sequence: PropTypes.array.isRequired
    }).isRequired
  ),
  disabled: PropTypes.bool
}

export default WorkflowSubmenu
